import React, { Component } from "react";
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import Cookies from "js-cookie";
import { LocaleProvider } from "antd";
import en_US from "antd/es/locale-provider/en_US";
import zh_CN from "antd/es/locale-provider/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import myLoadable from "./myLoadable";
// 多语言
import intl from "react-intl-universal";
import FetchData from '@ezviz/FetchData';

import "./App.css";
import "./App.less";

// moment.locale("zh-cn");
// import 'antd/dist/antd.css';
// common locale data
// require("intl/locale-data/jsonp/en.js");
// require("intl/locale-data/jsonp/zh.js");

// app locale data
// const locales = {
//   "en-us": require("./locales/en-us.json"),
//   "zh-cn": require("./locales/zh-cn.json")
// };

const OpenDoc = myLoadable({
  loader: () => import("./openDoc/index")
});
const OpenDocEn = myLoadable({
  loader: () => import("./openDocEn/index")
});

// const asynDownLoad = myLoadable({
//   loader: () => import("./downLoadPage/DownLoadPage")
// });
// const asynAppDownLoad = myLoadable({
//   loader: () => import("./appDownLoad/DownLoadPage")
// });
// const asynaAuth = myLoadable({
//   loader: () => import("./openauth/Index")
// });

// const asyncAuthrization = myLoadable({
//   loader: () => import("./authrization/Authrization")
// });
// const asynaAdmin = myLoadable({
//   loader: () => import("./admin")
// });


const initBroadcastChannel = () => {
  const setChannel = new BroadcastChannel('ezviz_login');
  setChannel.onmessage = (event) => {
    let docState = document.visibilityState
    if (!!event.data && docState == 'hidden') {
      const arr = event.data.split(",");
      console.log(arr)
      if (arr.length > 1) {
        // 文档中心接收到了信息 不要额外执行其他功能 重新加载页面即可
        switch (arr[0]) {
          case "logout":
            // 把搜索信息删除掉。
            window.location.href = window.location.href.replace(window.location.search,"")
            break;
          case "login_success":
            window.location.reload()
            break;
          case "user_change":
            window.location.reload()
            break;
        }
      }

    }

  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initDone: false,
      locale: "zh",
      protocolUrl: " ",
      privacyUrl: "",
      protocolEngUrl: "",
      privacyEngUrl: "",
      language: "zh-cn"
    };
  }
  componentDidMount() {

    initBroadcastChannel()
  }



  render() {
    return (
      <div className="openweb">
        <div className="app-router-container">
          <Router>
            <Switch>
              <Route path="/help/en/:id" component={OpenDocEn} exact />
              <Route path="/help/en" component={OpenDocEn} exact />
              <Route path="/help/:id" component={OpenDoc} exact />
              {/* <Route path="/help/zh/:id" component={OpenDoc} exact /> */}
              <Route path="/help" component={OpenDoc} exact />
              {/* <Redirect from="/help" to="/help" /> */}
            </Switch>
          </Router>
        </div>
      </div>

    );
  }
}

export default App;
